<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const knowledgeBaseId = computed(() => Number(route.params.id));

// 返回列表页
const goBack = () => {
  router.push({
    name: 'pilot_knowledge_bases_documents',
    params: { id: knowledgeBaseId.value },
  });
};
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-slate-white dark:bg-n-slate-800">
    <!-- Header -->
    <header class="sticky top-0 z-10 px-6 bg-n-slate-white dark:bg-n-slate-800">
      <div class="w-full mx-auto max-w-[60rem]">
        <!-- 第一行：返回按钮 + 标题 -->
        <div class="flex items-center justify-between h-16">
          <!-- 左侧：返回按钮 + 标题 -->
          <div class="flex items-center gap-3">
            <Button
              icon="i-lucide-arrow-left"
              size="sm"
              ghost
              @click="goBack"
            />
            <h1
              class="text-lg font-semibold text-n-slate-900 dark:text-n-slate-100"
            >
              {{ t('PILOT.KNOWLEDGE_BASES.SIDEBAR.MIP_SYNC_TITLE') }}
            </h1>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex-1 w-full px-6 overflow-y-auto">
      <div class="w-full mx-auto max-w-[60rem] py-6">
        <!-- 占位内容 -->
        <div class="flex flex-col items-center justify-center h-64 text-center">
          <div class="i-lucide-cloud-check text-6xl text-n-slate-7 mb-4" />
          <p class="text-base font-medium text-n-slate-12 mb-2">
            {{ t('PILOT.KNOWLEDGE_BASES.SIDEBAR.DEVELOPMENT_TOAST') }}
          </p>
          <p class="text-sm text-n-slate-11">此功能正在开发中，敬请期待</p>
        </div>
      </div>
    </main>

    <!-- Footer -->
    <footer
      class="sticky bottom-0 z-10 px-6 py-4 bg-n-slate-white dark:bg-n-slate-800 border-t border-n-weak"
    >
      <div class="w-full mx-auto max-w-[60rem]">
        <div class="flex gap-3 justify-end">
          <Button
            :label="t('PILOT.KNOWLEDGE_BASES.DOCUMENTS.CANCEL')"
            variant="faded"
            color="slate"
            @click="goBack"
          />
        </div>
      </div>
    </footer>
  </div>
</template>
